import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

import TablesLeads from "./pages/TablesLeads";
import TableCampaigns from "./pages/TableCampaigns";
import TableCostumers from "./pages/TableCostumers";
import SiteWrapper from "./componets/SiteWrapper";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PageForEmbbed from "./pages/embedPages/PageForEmbbed";
import NewPage from "./pages/embedPages/newPage/NewPage";
import LeadControl from "./pages/LeadControl";

const router = createBrowserRouter([
  {
    path: "/",
    element: <SiteWrapper></SiteWrapper>,
  },
  {
    path: "/table_leads",
    element: (
      <SiteWrapper>
        <TablesLeads />
      </SiteWrapper>
    ),
  },
  {
    path: "/table_campaigns",
    element: (
      <SiteWrapper>
        <TableCampaigns />
      </SiteWrapper>
    ),
  },
  {
    path: "/table_costumers",
    element: (
      <SiteWrapper>
        <TableCostumers />
      </SiteWrapper>
    ),
  },
  {
    path: "/table_Leads/embbed",
    element: <PageForEmbbed />,
  },
  {
    path: "/table_Leads/embbed/consent",
    element: <NewPage />,
  },
  {
    path: "/lead_control",
    element: (
      <SiteWrapper>
        <LeadControl />
      </SiteWrapper>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="282402008743-o0uvseev2o34vg246gc0m3cmsus4c2es.apps.googleusercontent.com">
      <RouterProvider router={router} />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
